import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UUID } from "angular2-uuid";
import { AProgessBarWizardComponent } from "../../components/common/progressbarwizard/iprogressbar.wizard.component";
import { NotificationLevel } from "../../models/enums/notificationlevel.enum";
import { IntegrationService } from "../../services/integration.service";
import { WebsocketService } from "../../services/websocket.service";

@Component({
    selector: 'iw-finish-page',
    templateUrl: './iw.finish.page.html',
    styleUrls: ['./iw.finish.page.css']
})
export class IntegrationWizardFinishPage extends AProgessBarWizardComponent implements OnInit {
    ImportSuccessful = false;
    ImportRunning = false;

    constructor(private cdRef: ChangeDetectorRef, private service: IntegrationService) {
        super();
        this.CanStepForwardValue = true;
    }

    ngOnInit(): void {
        if (this.WizardState) {
            const description = {
                FileType: this.WizardState.FileType,
                FileName: this.WizardState.UploadedFile.name,
                Options: JSON.stringify(this.WizardState.FileOptions),
                ExistingTable: this.WizardState.TargetTableID,
                NewTable: null,
                OverwriteExistingData: this.WizardState.DoOverwrite,
                UseBulk: this.WizardState.UseBulk,
                ColumnMapping: {},
                Channel: UUID.UUID()
            };
            if (this.WizardState.NewTable) {
                description.NewTable = {
                    DataModel: this.WizardState.DataModel.SID,
                    DataSource: this.WizardState.DataSource.SID,
                    TableName: this.WizardState.NewTableName
                };
            }
            this.WizardState.structure.Columns.forEach((col: any) => {
                if (col.Selected && col.MappedColumn) {
                    description.ColumnMapping[col.Name] = col.MappedColumn.Name;
                }
            });
            WebsocketService.WaitForWebSocketService().then(() => {
                const subScription = WebsocketService.MessageReceived.subscribe((response) => {
                    const parsed = JSON.parse(response);
                    if (parsed.Level === NotificationLevel.System &&
                        parsed.Channels && parsed.Channels.some((x: any) => x === description.Channel) &&
                        parsed.Type === 'evidanza.MiddleWare.Shared.Integration.IntegrationImportResult') {
                        subScription.unsubscribe();
                        WebsocketService.Unsubscribe([{ Channel: description.Channel, Level: [0] }]);
                        this.WizardState.ImportResult = JSON.parse(parsed.Content);
                        this.ImportRunning = false;
                        this.ImportSuccessful = this.WizardState.ImportResult && this.WizardState.ImportResult.RowResult &&
                            this.WizardState.ImportResult.RowResult.RowsImported == this.WizardState.ImportResult.RowResult.SourceRowCount;                        
                        this.cdRef.detectChanges();
                    }
                });
                WebsocketService.Subscribe([{ Channel: description.Channel, Level: [0] }]).then(() => {
                    this.service.ExecuteImport(description).subscribe();
                });
            });
            this.ImportRunning = true;
            this.cdRef.detectChanges();
        }
    }
}
